<template>
    <div class="fullScreen">
      <div :style="'height:100%;width:100%;position:absolute;'">
		  <video   @click="playVid" ref="introVid" :style="'position:absolute;top:0px;bottom:0px;margin:auto;left:0px;'"
		 	autoplay
		 	 width="100%" type="video/mp4" 
				:src="vidSrc">	</video>
				<audio ref="introSFX" src="../assets/audio/OceanSound.mp3" autoplay></audio>
    	<div class="vidWindow"  :style="'pointer-events:none;opacity:0;transform:scale('+screenScale+') translate('+screenLeft+'px,'+screenTop+'px);'">
			
		</div>
		<div class="seekerLogo" ref="logo"></div>
		<div v-if="showFarm || true" class="logoFarm" ref="logoFarm" :style="'bottom:'+vidBase()+'10px;'"></div>
		<div class="playBtn" @click="playVid" ref="playBtn" :style="'bottom:calc( '+(vidBase())+'px + 20% );'">
		PLAY
		</div>
		<audio crossOrigin="anonymous" ref="introAudio" ></audio>
		<div @click="transTo('game','Inside the Lighthouse...')" class="VO_Holder" style="width:80%">
		<TypeOn   v-if="showStory" :speed=".055" class="writeOn" v-html="introVO.text" :style="'font-size:25px;margin-bottom:'+vidBase()+'px;'">
			
		 </TypeOn>
		</div>
      </div>
	</div>
</template>

<script>
import screen from "@/mixins/screen"
import TypeOn from '@/components/TypeOn'
import gsap from "gsap";

var comp
export default {
   	components: {
		   TypeOn
	   },
	   mixins:[ screen],
		data: () => ({
			audioSrc:"../assets/audio/OceanSound.mp3",
			imageWidth:1920,
			imageHeight:1080,
			showStory:false,
			introVO:null,
			showFarm:false,
		}),
		mounted(){

			this.getIntroVO()
			
			this.$refs.introSFX.volume=this.fxVolume
			this.$refs.introAudio.volume=this.volume || 1
			this.$store.commit("setSettingsClass","settingsIcon intro")
		},
		computed:{
			
			fireBaseLoc(){
					return this.$store.getters.getFireBaseLoc					
			},
			vidSrc(){

			return this.fireBaseLoc+"video%2FIntro.mp4"
			},
			narratorSrc(){

				return this.fireBaseLoc+"audio%2Fnarration%2Fintro.mp3"
			},
			volume(){
				
      			return this.$store.getters.getvolume
    		},
			fxVolume(){
      			return this.$store.getters.getFXVolume
    		},
			screenLeft(){
       		return this.coverLeft(this.imageWidth,this.imageHeight)
    },
    screenTop(){
       return this.coverTop(this.imageWidth,this.imageHeight)
    },
    screenScale(){
      return this.coverScale(this.imageWidth,this.imageHeight)
    },
			
			
		},
		methods:{
			vidBase(){
				let vidHeight=Math.min(window.innerHeight,window.innerWidth/1920*1080)
				return (window.innerHeight-vidHeight)/2

			},
			async getIntroVO(){
				console.log("getIntroVO")
				 await this.$store.dispatch("retreiveText",{type:"Help",element:"H001_Intro"})
				 console.log("getIntroVO_2")
				 this.introVO=this.$store.getters.getTextElement({collection:"Help",doc:"H001_Intro"})
				 
			},
			playVid(){
				let self=this
				this.$refs.introVid.play()
				//this.$refs.introAudio.play()
				gsap.to(this.$refs.logo,{duration:3,autoAlpha:0,delay:3})
				gsap.to(this.$refs.playBtn,{duration:1,autoAlpha:0})
				//this.showFarm=true
				 gsap.to(self.$refs.logoFarm,{duration:3,autoAlpha:0})
				 this.$nextTick(() => {
					// gsap.set(self.$refs.logoFarm,{opacity:0})
					 //gsap.to(self.$refs.logoFarm,{duration:3,autoAlpha:1})
					 //gsap.to(self.$refs.logoFarm,{duration:2,autoAlpha:0,delay:5})
				 })
				 
				//gsap.to(this.$refs.logoFarm,{duration:1,autoAlpha:1})
				gsap.set(this,{showStory:true,delay:5})
				gsap.delayedCall(5,function(){
					self.$refs.introAudio.setAttribute('crossorigin', 'anonymous');
					console.log(self.narratorSrc)
					self.$refs.introAudio.src=self.narratorSrc
					self.$refs.introAudio.play()}),
					
					gsap.delayedCall(28,this.transTo,['game',"Inside the Lighthouse..."])
			},
			transTo(page,text){
				this.$refs.introAudio.pause()
        		let tText=text || "Meanwhile"
        		this.$store.dispatch('startTransition',{text:tText,to:page})
      		},
		},
		watch:{
			fxVolume(val){
				this.$refs.introAudio.volume=val
			}
		},
		beforeDestroy(){
			gsap.killTweensOf(this.transTo);
			
		}
	};



</script>


<style>
	.writeOn{
		
		width: 100%;
    margin: auto;
    text-align: left;
    font-size: 20px;
    color: #fffffff7;
    text-shadow: 0px 0px 10px;
	}
	.playBtn{
		border:#fff solid 1px;
		border-radius:5px;
		padding:5px;
		width:150px;
		text-align: center;
		font-size:20px;
		color:#fff;
		position:absolute;
		left:0px;
		right:0px;
		cursor:pointer;
		bottom:100px;
		margin:auto;
	}
	.vidWindow{
	transform-origin: top left;
    position:absolute;
    width:2000px;
    height:1125px;
    background-image:url("../assets/images/ship/cockpit3.png");
    background-position: 50% 12%;
    
    background-size: 350%;
    perspective: 2000px;
     perspective-origin: 50%;  
     pointer-events:none;
	}
	.seekerLogo{
		position:absolute;
		width:1024px;
		height:170px;
		max-width:70%;
		left:0px;
		right:0px;
		top:0px;
		bottom:0px;
		margin:auto;
		background-size:contain;
		background-repeat: no-repeat;
		background-position: center;
		 background-image:url("../assets/images/SeekerLogo2.png");
		

	}
	.logoFarm{
		position:absolute;
		width:500px;
		height:60px;
		max-width:70%;
		left:0px;
		right:0px;
		bottom:10px;
		margin:auto;
		opacity:1;
		background-size:contain;
		background-repeat: no-repeat;
		background-position: center;
	 	background-image:url("../assets/images/credits/WSLogoBand.png");
	}
	.VO_Holder{
		position: absolute;
		
    bottom: 10%;
	width: 60%;
	min-width:400px;
    pointer-events: auto;
	cursor:pointer;
	max-width:780px;
    margin: auto;
    left: 0%;
    right: 0%;
	}
</style>